import React, { Fragment, useEffect, useRef, useState } from "react";
import io from "socket.io-client";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import {
  chatMessage,
  modChatMessage,
  deleteChatMessage,
  deleteModChatMessage,
  getModerators,
  moderate,
  banUser,
  deleteModerator,
  timeoutUser,
  unTimeoutUser,
  getSupporters,
} from "../../actions/stream";
import { getGifs, getGifsSearch } from "../../actions/gif";
import { getProfileById } from "../../actions/profile";

import LoggedInNavRed from "../layout/IME/LoggedInNavRed";
import StreamerVideo from "../layout/Campaign/StreamerVideo";
import CampaignChat from "../layout/Campaign/CampaignChat";
import MiniChat from "../layout/IME/MiniChat";
import CampaignModChat from "../layout/Campaign/CampaignModChat";
import ChatGIFModal from "../layout/IME/ChatGIFModal";
import RecentSupporters from "../layout/Campaign/RecentSupporters";
import StreamSecondaryLogo from "../layout/IME/StreamSecondaryLogo";
import GreenSpinner from "../../img/Green_Spinner.gif";
import ReportChatUser from "../layout/IME/ReportChatUser";
import BanUser from "../layout/IME/BanUser";

import TwoFARequest from "../layout/Innovators/TwoFARequest";
import Offline from "../layout/IME/Offline";
import StreamNotifications from "../layout/IME/StreamNotifications";
import MiniModChat from "../layout/IME/MiniModChat";

const ENDPOINT = "https://imelive.tv";

let socket;

const CampaignLiveStream = ({
  match,
  auth: { user, channelid, jobtitle, location, verified },
  getGifs,
  gif: { gifs, loading },
  profile: { profile },
  stream: {
    chatMessages,
    modChatMessages,
    moderators,
    supporters,
    stream_loading,
  },
  getProfileById,
  chatMessage,
  modChatMessage,
  deleteChatMessage,
  deleteModChatMessage,
  getModerators,
  moderate,
  deleteModerator,
  timeoutUser,
  banUser,
  unTimeoutUser,
  getSupporters,
  isAuthenticated,
}) => {
  const [showAuthentication, setShowAuthentication] = useState(true);
  const [showGIFs, setshowGIFs] = useState(false);
  const [showModGIFs, setshowModGIFs] = useState(false);
  const [gifSearch, setGifSearch] = useState(false);
  const [modGifSearch, setModGifSearch] = useState(false);
  const [showGIFSearch, setShowGifs] = useState(false);
  const [text, setText] = useState("");
  const [showReportUser, setShowReportUser] = useState({
    submit: false,
    confirm: false,
  });
  const [reportedUser, setReportedUser] = useState({
    role: "",
    channelid: "",
    avatar: "",
    firstname: "",
    lastname: "",
    text: "",
    image: "",
    video: "",
    gif: "",
  });
  const [showBanUser, setShowBanUser] = useState({
    submit: false,
    confirm: false,
  });
  const [bannedUser, setBannedUser] = useState({
    role: "",
    channelid: "",
    avatar: "",
    firstname: "",
    lastname: "",
    text: "",
    image: "",
    video: "",
    gif: "",
    messsage: {},
    messages: [],
  });
  const [filterText, setFilterText] = useState("");
  const [filterModText, setFilterModText] = useState("");
  const [filterTextNotifications, setFilterTextNotifications] = useState("");
  const [foundGif, setGif] = useState("");
  const [foundModGif, setModGif] = useState("");
  const [showModGIFSearch, setShowModGifs] = useState(false);
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [modmessage, setModMessage] = useState("");
  const [modmessages, setModMessages] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [room, setRoom] = useState(match.params.channelid);
  const [imeBotAvi, setimebotavi] = useState("Innovate_Me_logo_red.png");
  const [showChat, setShowChat] = useState(true);
  const [showModChat, setShowModChat] = useState(false);
  const [showMiniChat, setShowMiniChat] = useState(true);
  const [showMiniModChat, setShowMiniModChat] = useState(false);
  const [showNotifications, setShowNotifications] = useState(true);
  const [descriptionText, setDescription] = useState("");
  const [keywordText, setKeyword] = useState("");
  const [keywordsText, setKeywordsText] = useState([]);
  const [keywords, setKeywords] = useState([]);
  const [viewerCount, setViewerCount] = useState([]);
  const [descriptionObject, setDescriptionObject] = useState({
    updatedDescription: "",
  });
  const [isError, setIsError] = useState(false);
  const [gifMode, setGifMode] = useState(false);

  const inputRefDescription = useRef(null);
  const inputRefKeywords = useRef(null);

  const deleteMessage = (message, chatMessages) => {
    deleteChatMessage("roland", message);
    socket.emit("deleteMessage", message, chatMessages);
  };

  const deleteModMessage = (modmessage, modChatMessages) => {
    deleteModChatMessage("roland", modmessage);
    socket.emit("deletedModMessage", modmessage, modChatMessages);
  };

  const timeoutDeleteMessage = (message) => {
    deleteChatMessage(profile.channelid, message);
  };

  const banDeleteMessage = (message) => {
    deleteChatMessage("roland", message);
  };

  const timeoutDeleteModMessage = (modmessage) => {
    deleteModChatMessage("roland", modmessage);
  };

  const TimeOut = (message, profile, chatMessages) => {
    timeoutUser(message.channelid, profile.channelid);

    socket.emit("timeoutUser", message, chatMessages);

    setTimeout(() => {
      unTimeoutUser(message.channelid);
    }, 300000);
  };

  const TimeOutMod = (modmessage, profile, modChatMessages) => {
    timeoutUser(modmessage.channelid, profile.channelid);

    socket.emit("timeoutModUser", modmessage, modChatMessages);

    setTimeout(() => {
      unTimeoutUser(modmessage.channelid);
    }, 300000);
  };

  const gifModeActive = (gifMode) => {
    setGifMode(true);

    socket.emit("updateGifMode", gifMode);
  };

  const gifModeInactive = (gifMode) => {
    setGifMode(false);

    socket.emit("updateGifMode", gifMode);
  };

  const clearDescription = () => {
    setDescriptionObject({
      ...descriptionObject,
      updatedDescription: "",
    });
    setDescription("");

    socket.emit("clearDescription");
  };

  const clearTags = () => {
    setKeywords([keywordsText.splice(0, keywordsText.length)]);
    socket.emit("clearTags");
  };

  const Ban = (
    channelid,
    profile_channelid,
    text,
    isCurrent,
    description,
    video,
    image,
    gif,
  ) => {
    banUser(
      channelid,
      profile_channelid,
      text,
      isCurrent,
      description,
      video,
      image,
      gif,
    );

    socket.emit("banUser", bannedUser.message, bannedUser.messages);
  };

  // useEffect(() => {
  //   getProfileById(match.params.channelid);
  // }, [getProfileById, match.params.channelid]);

  // time = evaluate(time);
  // videoduration = evaluate(videoduration);
  const playerRef = useRef(null);

  useEffect(() => {
    getGifs();
    getProfileById(profile.channelid);
    getModerators(profile.channelid);
    setRoom(profile.channelid);
    getSupporters();
  }, [
    getGifs,
    getProfileById,
    getModerators,
    getSupporters,
    match.params.channelid,
  ]);

  useEffect(() => {
    socket = io(ENDPOINT);

    socket.on("roomUsers", (users) => {
      setViewerCount([...users.users]);
    });

    socket.emit("getDescription", (description) => {
      setDescriptionObject({
        ...descriptionObject,
        updatedDescription: description.description,
      });
    });

    socket.on("description", (description) => {
      setDescriptionObject({
        ...descriptionObject,
        updatedDescription: description.descriptionText,
      });
    });

    socket.emit("getKeywords", (keywords) => {
      setKeywords([...keywords.keywords]);
    });

    socket.emit("getGifMode");

    socket.on("donation", (message) => {
      const messageObject = {
        messageid: message.messageid,
        role: message.role,
        channelid: message.channelid,
        firstname: message.firstname,
        lastname: message.lastname,
        avatar: message.avatar,
        text: `New Donation from ${message.channelid}!`,
        amount: message.amount,
        founding_supporter_type: message.founding_supporter_type,
        type: "notification",
      };

      chatMessages.push(messageObject);
    });

    if (isAuthenticated) {
      socket.on("roomUsers", (users) => {
        setViewerCount([...users.users]);
      });

      socket.emit("joinRoom", {
        imebotavi: imeBotAvi,
        channelid: user.channelid,
        role: user.role,
        avatar: user.avatar,
        firstname: user.firstname,
        lastname: user.lastname,
        room: profile.channelid,
      });
    }

    socket.on("timedOutUser", (message) => {
      const messageObject = {
        messageid: message.messageid,
        role: message.role,
        channelid: message.channelid,
        firstname: message.firstname,
        lastname: message.lastname,
        avatar: message.avatar,
        text: message.text,
        gif: "",
        room: message.room,
        deleted: false,
        timedout: true,
        founding_supporter_type: message.founding_supporter_type,
        type: "message",
      };

      setMessages([...message.messages, messageObject]);
    });

    socket.on("timedOutModUser", (modmessage) => {
      const messageObject = {
        messageid: modmessage.messageid,
        role: modmessage.role,
        channelid: modmessage.channelid,
        firstname: modmessage.firstname,
        lastname: modmessage.lastname,
        avatar: modmessage.avatar,
        text: modmessage.text,
        gif: "",
        room: modmessage.room,
        deleted: false,
        timedout: true,
        founding_supporter_type: modmessage.founding_supporter_type,
        type: "message",
      };

      setModMessages([...modmessage.modmessages, messageObject]);
    });

    socket.on("bannedUser", (message) => {
      const messageObject = {
        messageid: message.messageid,
        role: message.role,
        channelid: message.channelid,
        firstname: message.firstname,
        lastname: message.lastname,
        avatar: message.avatar,
        text: message.text,
        gif: "",
        room: message.room,
        deleted: true,
        timedout: false,
        founding_supporter_type: message.founding_supporter_type,
        type: "message",
      };

      setMessages([...message.messages, messageObject]);
    });

    return () => {
      if (socket) {
        socket.emit("leave");

        socket.disconnect();

        socket.off();

        socket.close();

        socket.on("roomUsers", (users) => {
          setViewerCount([...users.users]);
        });
      }
    };
  }, [ENDPOINT, match.params.channelid, user]);

  useEffect(() => {
    socket.on("welcomeMessage", (message) => {
      setMessages([...messages, message]);
    });
  }, [ENDPOINT, match.params.channelid, user]);

  useEffect(() => {
    socket.on("description", (description) => {
      setDescriptionObject({
        ...descriptionObject,
        updatedDescription: description.description,
      });
    });
  }, [descriptionObject.updatedDescription]);

  useEffect(() => {
    socket.on("keywords", (keywords) => {
      setKeywords([...keywords.keywords]);
    });
  }, [keywords]);

  useEffect(() => {
    socket.on("setGifMode", (currentGifMode) => {
      if (currentGifMode) {
        setGifMode(false);
      } else {
        setGifMode(true);
      }
    });
  }, [gifMode]);

  useEffect(() => {
    socket.on("message", (message) => {
      chatMessages.push(message);
    });
  }, [chatMessages]);

  useEffect(() => {
    socket.on("modmessage", (modmessage) => {
      modChatMessages.push(modmessage);
    });
  }, [modChatMessages]);

  const removeMessage = (chatMessages, message) => {
    const messageObject = {
      messageid: message.messageid,
      role: message.role,
      channelid: message.channelid,
      firstname: message.firstname,
      lastname: message.lastname,
      avatar: message.avatar,
      text: message.text,
      gif: "",
      room: message.room,
      deleted: true,
      timedout: false,
      founding_supporter_type: message.founding_supporter_type,
      type: "message",
    };

    const removeIndex = chatMessages
      .map((x) => x.messageid)
      .indexOf(message.messageid);

    chatMessages.splice(removeIndex);

    chatMessages.push(messageObject);
  };

  useEffect(() => {
    socket.on("messageDeleted", (message) => {
      removeMessage(chatMessages, message);
    });
  }, [chatMessages]);

  useEffect(() => {
    socket.on("modMessageDeleted", (modmessage) => {
      const messageObject = {
        messageid: modmessage.messageid,
        role: modmessage.role,
        channelid: modmessage.channelid,
        firstname: modmessage.firstname,
        lastname: modmessage.lastname,
        avatar: modmessage.avatar,
        text: modmessage.text,
        gif: "",
        room: modmessage.room,
        deleted: true,
        timedout: false,
        founding_supporter_type: modmessage.founding_supporter_type,
        type: "message",
      };

      const removeIndex = modChatMessages
        .map((x) => x.messageid)
        .indexOf(modmessage.messageid);

      modChatMessages.splice(removeIndex);

      modChatMessages.push(messageObject);
    });
  }, [modChatMessages]);

  useEffect(() => {
    socket.on("donation", (messageObject) => {
      chatMessages.push(messageObject);

      setNotifications([messageObject, ...notifications]);
    });
  }, [chatMessages, notifications]);

  const sendUpdatedKeywords = (e) => {
    e.preventDefault();
    if (keywordsText.length > 0) {
      socket.emit("updateKeywords", keywordsText);
    }
  };

  const sendModMessage = (e) => {
    e.preventDefault();
    if (modmessage || foundModGif !== "") {
      modChatMessage(profile.channelid, modmessage, foundModGif);
      socket.emit(
        "modChatMessage",
        modmessage,
        foundModGif,
        user.firstname,
        user.lastname,
        user.avatar,
        room,
      );
      setModMessage("");
      setModGif("");
      setshowModGIFs(false);
    }
  };

  const sendMessage = (e) => {
    e.preventDefault();
    if (message || (foundGif !== "" && room !== "")) {
      chatMessage(profile.channelid, message, foundGif);
      socket.emit(
        "chatMessage",
        message,
        foundGif,
        user.firstname,
        user.lastname,
        user.avatar,
        room,
      );
      setMessage("");
      setGif("");
      setshowGIFs(false);
    }
  };

  useEffect(() => {
    if (chatMessages.length > 20) {
      chatMessages.shift();
    }
  }, [chatMessages]);

  useEffect(() => {
    if (modChatMessages.length > 20) {
      modChatMessages.shift();
    }
  }, [modChatMessages]);

  const maxLength = 100;

  const handleInputChange = (e) => {
    setMessage(e.target.value);
  };

  const sendDescription = (e) => {
    e.preventDefault();
    if (descriptionText !== "") {
      //  streamDescriptionTitle(profile.channelid, descriptionText);
      socket.emit("updateDescription", descriptionText);
    }
  };

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {verified && !isAuthenticated && (
        <TwoFARequest
          setShowAuthentication={setShowAuthentication}
          channelid={channelid}
          jobtitle={jobtitle}
          location={location}
        />
      )}
      {showBanUser.submit && (
        <BanUser
          bannedUser={bannedUser}
          setShowBanUser={setShowBanUser}
          profile_id={profile.channelid}
          Ban={Ban}
        />
      )}
      {showReportUser.submit && (
        <ReportChatUser
          reportedUser={reportedUser}
          setShowReportUser={setShowReportUser}
          profile_id={profile.channelid}
        />
      )}
      {showGIFSearch && (
        <ChatGIFModal
          user={user}
          profile={profile}
          message={message}
          setGif={setGif}
          foundGif={foundGif}
          showGIFSearch={showGIFSearch}
          setShowGifs={setShowGifs}
          getGifs={getGifs}
          getGifsSearch={getGifsSearch}
          gifs={gifs}
          handleInputChange={handleInputChange}
          sendMessage={sendMessage}
          isAuthenticated={isAuthenticated}
        />
      )}
      <LoggedInNavRed />
      <section
        className={
          showChat && showNotifications
            ? "flex-only-alt-notifications"
            : showModChat && showNotifications
              ? "flex-only-alt-notifications"
              : showChat && !showNotifications
                ? "flex-only-alt-live-stream"
                : showModChat && !showNotifications
                  ? "flex-only-alt-live-stream"
                  : !showChat && showNotifications
                    ? "flex-only-alt-live-stream"
                    : !showModChat && showNotifications
                      ? "flex-only-alt-live-stream"
                      : !showChat && !showModChat && !showNotifications
                        ? "flex-no-chat-stream"
                        : ""
        }
      >
        <div className="main-stream-content">
          <div className="video-chat grey" ref={playerRef}>
            {/* {!isError ? (
                          <StreamerVideo
                            profile={profile}
                            showChat={showChat}
                            descriptionObject={descriptionObject}
                            viewerCount={viewerCount}
                            setIsError={setIsError}
                          />
                        ) : (
                          // : !isError && stream_loading ? (
                          //   <div className="profile-error">
                          //     <img src={GreenSpinner} alt="green-spinner" />
                          //   </div>
                          // )
                          isError && (
                            <Offline
                              profile={profile}
                              showChat={showChat}
                              viewerCount={viewerCount}
                            />
                          )
                        )} */}
            <StreamerVideo
              profile={profile}
              showChat={showChat}
              descriptionObject={descriptionObject}
              viewerCount={viewerCount}
              setIsError={setIsError}
            />
            {!showChat && !showModChat && showNotifications && (
              <div className="showchaticon" onClick={() => setShowChat(true)}>
                <i className="far fa-comment fa-2x red"></i>
              </div>
            )}
            {!showNotifications && showChat && (
              <div
                className="showchaticon"
                onClick={() => setShowNotifications(true)}
              >
                <i className="fa-solid fa-bell fa-2x red"></i>
              </div>
            )}
            {!showNotifications && showModChat && (
              <div
                className="showchaticon"
                onClick={() => setShowNotifications(true)}
              >
                <i className="fa-solid fa-bell fa-2x red"></i>
              </div>
            )}
            {!showNotifications && !showChat && !showModChat && (
              <div className="showchaticon-container">
                <div
                  className="showchaticon-alt"
                  onClick={() => setShowNotifications(true)}
                >
                  <i className="fa-solid fa-bell fa-2x red"></i>
                </div>
                <div
                  className="showchaticon-alt"
                  onClick={() => setShowChat(true)}
                >
                  <i className="far fa-comment fa-2x red"></i>
                </div>
              </div>
            )}
          </div>
          <div className="stream-keywords">
            <ul>
              {keywords.length > 0 &&
                keywords.map((keyword, index) => {
                  return (
                    <li className="stream-text-keywords red" key={index}>
                      {keyword}
                    </li>
                  );
                })}
            </ul>
          </div>
          <div className="stream-information-container">
            <div className="stream-info-grid">
              <div className="stream-grid-container">
                <div className="stream-info">
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${user.avatar}`}
                    className="streamer-user-avi"
                  />
                  <div className="helper-container">
                    <div className="sub-section-container-alt">
                      <div className="campaign-input-label-container">
                        <div className="flex-only mb-10">
                          <p className="sub-section red">
                            Update Stream Description
                          </p>
                        </div>
                        <div
                          onClick={() => clearDescription()}
                          className="add-keyword background-red"
                        >
                          Clear Stream Description
                        </div>
                        <input
                          type="text"
                          ref={inputRefDescription}
                          name="keywords"
                          value={descriptionText}
                          className="input-item"
                          placeholder="Enter Stream Description"
                          onChange={(e) => setDescription(e.target.value)}
                        />
                        {descriptionText !== "" && (
                          <div
                            className="add-keyword background-red"
                            onClick={(e) => {
                              sendDescription(e);
                              inputRefDescription.current.focus();
                            }}
                            onKeyPress={(e) =>
                              e.key === "Enter" ? sendDescription(e) : null
                            }
                          >
                            Enter Stream Description
                          </div>
                        )}
                      </div>
                      {descriptionObject.updatedDescription !== "" && (
                        <p className="stream-description-update">
                          {descriptionObject.updatedDescription}
                        </p>
                      )}
                      <div className="sub-section-container-alt">
                        <div className="campaign-input-label-container">
                          <div className="flex-only mb-10">
                            <p className="sub-section red">Stream Tags</p>
                          </div>
                          <div
                            onClick={() => {
                              clearTags();
                            }}
                            className="add-keyword background-red"
                          >
                            Clear Stream Tag(s)
                          </div>
                          <input
                            type="text"
                            ref={inputRefKeywords}
                            name="keywords"
                            value={keywordText}
                            className="input-item"
                            placeholder="Enter a Stream Tag"
                            onChange={(e) => setKeyword(e.target.value)}
                          />
                          {keywordText !== "" && (
                            <div
                              className="add-keyword background-red"
                              onClick={() => {
                                setKeywordsText([...keywordsText, keywordText]);
                                setKeyword("");
                                inputRefKeywords.current.focus();
                              }}
                            >
                              Add Stream Tag
                            </div>
                          )}
                        </div>
                        {keywordsText.map((word, index) => {
                          return (
                            <li className="keywordsArray red" key={index}>
                              {word}
                              <i
                                className="fas fa-times fa-sm white times-sm mx-10"
                                onClick={() => {
                                  keywordsText.splice(index, 1);
                                  setKeywordsText([...keywordsText]);
                                }}
                              ></i>
                            </li>
                          );
                        })}
                      </div>
                      {keywordsText.length > 0 && (
                        <div
                          className="add-keyword background-red"
                          onClick={(e) => {
                            sendUpdatedKeywords(e);
                          }}
                        >
                          Update Stream Tags
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="stream-grid-container-alt">
                <StreamSecondaryLogo />
                {!gifMode && (
                  <div
                    onClick={() => gifModeActive(gifMode)}
                    className="gif-mode red bold"
                  >
                    Turn GIF Mode On{" "}
                    <i i className="far fa-check-circle fa-lg mx-5 red"></i>
                  </div>
                )}
                {gifMode && (
                  <div
                    onClick={() => gifModeInactive(gifMode)}
                    className="gif-mode red bold"
                  >
                    Turn GIF Mode Off{" "}
                    <i i className="far fa-times-circle fa-lg mx-5 red"></i>
                  </div>
                )}
              </div>
            </div>
          </div>
          {showMiniChat && (
            <div className="mini-chat-container">
              <MiniChat
                user={user}
                profile={profile}
                chatMessages={chatMessages}
                messages={messages}
                message={message}
                deleteMessage={deleteMessage}
                timeoutDeleteMessage={timeoutDeleteMessage}
                gifs={gifs}
                setGif={setGif}
                foundGif={foundGif}
                showGIFSearch={showGIFSearch}
                setShowGifs={setShowGifs}
                gifSearch={gifSearch}
                setGifSearch={setGifSearch}
                sendMessage={sendMessage}
                text={text}
                setText={setText}
                setShowMiniChat={setShowMiniChat}
                setShowMiniModChat={setShowMiniModChat}
                handleInputChange={handleInputChange}
                maxLength={maxLength}
                filterText={filterText}
                setFilterText={setFilterText}
                setShowReportUser={setShowReportUser}
                setReportedUser={setReportedUser}
                setShowBanUser={setShowBanUser}
                setBannedUser={setBannedUser}
                moderators={moderators}
                moderate={moderate}
                deleteModerator={deleteModerator}
                TimeOut={TimeOut}
                banDeleteMessage={banDeleteMessage}
                Ban={Ban}
                viewerCount={viewerCount}
                setMessage={setMessage}
                gifMode={gifMode}
              />
            </div>
          )}
          {showMiniModChat && (
            <MiniModChat
              user={user}
              profile={profile}
              modChatMessages={modChatMessages}
              modmessage={modmessage}
              setModMessage={setModMessage}
              deleteModMessage={deleteModMessage}
              TimeOutMod={TimeOutMod}
              gifs={gifs}
              setModGif={setModGif}
              foundModGif={foundModGif}
              showModGIFs={showModGIFs}
              setShowModGifs={setShowModGifs}
              showModGIFSearch={showModGIFSearch}
              setModGifSearch={setModGifSearch}
              sendModMessage={sendModMessage}
              text={text}
              maxLength={maxLength}
              setFilterModText={setFilterModText}
              filterModText={filterModText}
              setShowMiniModChat={setShowMiniModChat}
              setShowMiniChat={setShowMiniChat}
              setShowReportUser={setShowReportUser}
              setReportedUser={setReportedUser}
              moderators={moderators}
              deleteModerator={deleteModerator}
              TimeOut={TimeOut}
              timeoutDeleteModMessage={timeoutDeleteModMessage}
              setMessage={setMessage}
            />
          )}
        </div>
        {showNotifications && (
          <StreamNotifications
            user={user}
            profile={profile}
            message={message}
            deleteMessage={deleteMessage}
            timeoutDeleteMessage={timeoutDeleteMessage}
            gifs={gifs}
            setGif={setGif}
            foundGif={foundGif}
            showGIFs={showGIFs}
            setshowGIFs={setshowGIFs}
            gifSearch={gifSearch}
            setGifSearch={setGifSearch}
            sendMessage={sendMessage}
            text={text}
            setText={setText}
            setShowNotifications={setShowNotifications}
            handleInputChange={handleInputChange}
            maxLength={maxLength}
            filterTextNotifications={filterTextNotifications}
            setFilterTextNotifications={setFilterTextNotifications}
            setShowReportUser={setShowReportUser}
            setReportedUser={setReportedUser}
            setBannedUser={setBannedUser}
            moderators={moderators}
            moderate={moderate}
            deleteModerator={deleteModerator}
            TimeOut={TimeOut}
            Ban={Ban}
            notifications={notifications}
            setNotifications={setNotifications}
          />
        )}
        {showModChat && !showChat && (
          <CampaignModChat
            user={user}
            profile={profile}
            modChatMessages={modChatMessages}
            modmessage={modmessage}
            setModMessage={setModMessage}
            deleteModMessage={deleteModMessage}
            TimeOutMod={TimeOutMod}
            gifs={gifs}
            setModGif={setModGif}
            foundModGif={foundModGif}
            showModGIFs={showModGIFs}
            setshowModGIFs={setshowModGIFs}
            modGifSearch={modGifSearch}
            setModGifSearch={setModGifSearch}
            sendModMessage={sendModMessage}
            text={text}
            setFilterModText={setFilterModText}
            filterModText={filterModText}
            setShowModChat={setShowModChat}
            setShowChat={setShowChat}
            setShowReportUser={setShowReportUser}
            setReportedUser={setReportedUser}
            moderators={moderators}
            deleteModerator={deleteModerator}
            TimeOut={TimeOut}
            timeoutDeleteModMessage={timeoutDeleteModMessage}
            setMessage={setMessage}
            viewerCount={viewerCount}
            maxLength={maxLength}
          />
        )}
        {showChat && !showModChat && (
          <CampaignChat
            user={user}
            profile={profile}
            chatMessages={chatMessages}
            messages={messages}
            message={message}
            deleteMessage={deleteMessage}
            timeoutDeleteMessage={timeoutDeleteMessage}
            gifs={gifs}
            setGif={setGif}
            foundGif={foundGif}
            showGIFs={showGIFs}
            setshowGIFs={setshowGIFs}
            gifSearch={gifSearch}
            setGifSearch={setGifSearch}
            sendMessage={sendMessage}
            text={text}
            setText={setText}
            setShowChat={setShowChat}
            setShowModChat={setShowModChat}
            handleInputChange={handleInputChange}
            maxLength={maxLength}
            filterText={filterText}
            setFilterText={setFilterText}
            setShowReportUser={setShowReportUser}
            setReportedUser={setReportedUser}
            setShowBanUser={setShowBanUser}
            setBannedUser={setBannedUser}
            moderators={moderators}
            moderate={moderate}
            deleteModerator={deleteModerator}
            TimeOut={TimeOut}
            banDeleteMessage={banDeleteMessage}
            Ban={Ban}
            viewerCount={viewerCount}
            setMessage={setMessage}
            gifMode={gifMode}
          />
        )}
      </section>
    </Fragment>
  );
};

CampaignLiveStream.propTypes = {
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
  getProfileById: PropTypes.func.isRequired,
  chatMessage: PropTypes.func.isRequired,
  modChatMessage: PropTypes.func.isRequired,
  deleteChatMessage: PropTypes.func.isRequired,
  deleteModChatMessage: PropTypes.func.isRequired,
  getModerators: PropTypes.func.isRequired,
  moderate: PropTypes.func.isRequired,
  deleteModerator: PropTypes.func.isRequired,
  timeoutUser: PropTypes.func.isRequired,
  banUser: PropTypes.func.isRequired,
  unTimeoutUser: PropTypes.func.isRequired,
  getGifs: PropTypes.func.isRequired,
  getGifsSearch: PropTypes.func.isRequired,
  getSupporters: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  profile: state.profile,
  stream: state.stream,
  gif: state.gif,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  getProfileById,
  chatMessage,
  modChatMessage,
  deleteChatMessage,
  deleteModChatMessage,
  getModerators,
  moderate,
  deleteModerator,
  timeoutUser,
  banUser,
  unTimeoutUser,
  getGifs,
  getGifsSearch,
  getSupporters,
})(CampaignLiveStream);
